<template>
  <div id="loginheaderDiv">
    <el-row>
      <el-col :xs="24" :md="24">
        <div class="logo">
          <img v-show='logimage' src="../../../static/images/Logo.png" />
          <img v-show='logimage2' style="width:70px;" src="../../../static/images/logo01.png" />
        </div>
      </el-col>
      <!-- <el-col :xs="24" :md="12">
        <div class="layout-ceiling">        
          <Dropdown @on-click="changelocal" trigger="click">
            <a href="#"> {{$t(this.localelang)}} </a>
              <Icon type="ios-arrow-down" size='6px'></Icon> 
              <DropdownMenu slot="list">
                  <DropdownItem  name='zh'>简体中文</DropdownItem>
                  <DropdownItem  name='en'>English</DropdownItem>              
              </DropdownMenu>
          </Dropdown>
        </div>
      </el-col> -->
    </el-row>
  </div>
</template>

<script>
  import * as validate from '@/utils/validate'
  export default {
      name:'IndexHeader',
      mounted() {       
          var browserLanguage= (navigator.language || navigator.browserLanguage).toLowerCase();
          browserLanguage = browserLanguage.substr(0, 2);//截取browserLanguage前2位字符
          browserLanguage = 'en';
          if(browserLanguage == 'zh'){
              this.$i18n.locale='zh';
              this.imgSrc='../../../static/images/Logo.png'
              this.logimage=true
              this.logimage2=false
          }else{
              this.$i18n.locale='en';
              this.imgSrc='../../../static/images/logo01.png'
              this.logimage=false
              this.logimage2=true              
          }
      },
      data () {
        return {
            logimage:true,
            logimage2:false,
            imgSrc: "",
            localelang:'languages',
            locale: [],
        }
      },
      methods: {     
        changelocal(name){
          if(name=='zh'){
            this.$i18n.locale='zh'
            this.localelang='简体中文'
            this.imgSrc='../../../static/images/Logo.png'
            this.logimage=true
            this.logimage2=false
          }else{
            this.$i18n.locale='en'
            this.localelang='English'
            this.imgSrc='../../../static/images/logo01.png'
            this.logimage=false
            this.logimage2=true
          }
        },
      }
  }
</script>

<style lang="less" type="text/less">
  #loginheaderDiv{
    width: 100%;
    height: 60px;
    font-size: 14px;
    background:rgba(1,122,255,1);
    .logo{
        width: 90px;
        display: inline;
    }
    .logo img{
        margin: 16px 0 15px 20px;
    }
    .layout-ceiling{
        color:rgba(251,252,254,1) !important;
        margin-right: 20px;
        float: right;
        margin-top: 20px;
    }
    .layout-ceiling  a {
        color:rgba(251,252,254,1) !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/public/indexheader.vue